import { createTheme } from "@mui/material";
import { customMuiTypography } from "./typography";
import { customMuiButton } from "./button";
import { customMuiCard } from "./card";
import { customMuiTextField } from "./textfield";
import { customMuiAlert } from "./alert";
import { customMuiCheckbox } from "./checkbox";
import { APP_COLORS } from "../enums";
import { customColors } from "./colors";

const theme = createTheme({
  palette: customColors.palette,
  components: {
    MuiTypography: customMuiTypography,
    MuiButton: customMuiButton,
    MuiCard: customMuiCard,
    MuiTextField: customMuiTextField,
    MuiAlert: customMuiAlert,
    MuiCheckbox: customMuiCheckbox,
    MuiSelect: {
      styleOverrides: {
        root: {
          backgroundColor: APP_COLORS.white,
          borderRadius: 10,
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: ({ theme }) => ({
          width: theme.breakpoints.up("sm") ? 720 : "100%",
          maxWidth: "100vw",
        }),
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: ({ theme }) => ({
          background: `linear-gradient(180deg, ${APP_COLORS.headerIconColor} 0%, ${APP_COLORS.white} 100%)`,
          borderRadius: 20,
        }),
      },
    },
    MuiDivider: {
      styleOverrides: {
        root: {
          borderColor: APP_COLORS.greyLight2,
          marginTop: 16,
          marginBottom: 16,
        },
      },
    },
    MuiSkeleton: {
      styleOverrides: {
        root: {
          height: 10,
          background: "linear-gradient(90deg, #EDEDED 0%, rgba(255, 255, 255, 0) 100%)",
        },
      },
      variants: [
        {
          props: { variant: "rectangular" },
          style: {
            borderRadius: "6px",
          },
        },
      ],
      defaultProps: {
        variant: "rectangular",
      },
    },
  },
});

export { theme };
